export default __webpack_public_path__ + "static/media/density-of-solid.32d32ce3.jpg";